import { Form } from 'formik';
import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 2rem;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  @media screen and (max-width: ${(props) => props.theme.size?.large}) {
    gap: 3rem;
  }
  @media screen and (max-width: ${(props) => props.theme.size?.medium}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0;
  }
`;

export const ImageContainer = styled.div`
  @media screen and (max-width: ${(props) => props.theme.size?.medium}) {
    .button_change_perfil {
      display: none;
    }
  }
`;

export const PrefilContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  width: 15rem;
  height: 17rem;

  @media screen and (max-width: ${(props) => props.theme.size?.medium}) {
    width: 9rem;
  }

  @media screen and (max-width: ${(props) => props.theme.size?.xsmall}) {
    height: 10rem;
  }
`;

export const ImgAvatar = styled.img`
  width: 14rem;
  height: 14rem;
  object-fit: cover;
  object-position: center;
  border-radius: 50%;
  z-index: 1;

  @media screen and (max-width: ${(props) => props.theme.size?.medium}) {
    width: 8rem;
    height: 8rem;
  }
`;

export const ImgCircle = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
  width: 15rem;
  height: 15rem;
  pointer-events: none;

  @media screen and (max-width: ${(props) => props.theme.size?.medium}) {
    width: 9rem;
    height: 9rem;
  }
`;

export const ImgPlus = styled.img`
  display: none;
  position: absolute;
  z-index: 2;
  width: 20px;
  top: 50%;
  left: 50%;

  @media screen and (max-width: ${(props) => props.theme.size?.medium}) {
    display: block;
    transform: translate(-50%, -50%) translate(2.4rem, 2.4rem);
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  flex-direction: column;

  padding-top: 5rem;
  padding-left: ${({ theme }) =>
    theme.fontSizeType == 'xLarge' || theme.fontSizeType == 'large'
      ? '2rem'
      : '0'};

  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;

  @media screen and (max-width: ${(props) => props.theme.size?.xlarge}) {
    padding-top: 0rem;
  }

  @media screen and (max-width: ${(props) => props.theme.size?.medium}) {
    text-align: center;
    justify-content: center;
    align-items: center;
  }

  @media screen and (max-width: ${(props) => props.theme.size?.xsmall}) {
    padding-top: 1rem;
  }
`;

export const Password = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 3rem;

  @media screen and (max-width: ${(props) => props.theme.size?.xlarge}) {
    flex-direction: column;
    align-items: start;
    gap: 1rem;
  }

  @media screen and (max-width: ${(props) => props.theme.size?.medium}) {
    align-items: center;
    margin-bottom: 1rem;
  }
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: row;
  align-items: end;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  gap: 2rem;
`;

export const P = styled.p`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs16};
`;

export const B = styled.b`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

export const H3 = styled.h3``;

export const Polo = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 1rem;
`;

export const InputFilePlus = styled.label`
  input[type='file'] {
    display: none;
  }
`;

export const InputFile = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${({ theme }) => theme.colors?.primary};
  border-radius: 10px;
  color: ${({ theme }) => theme.colors?.text.tertiary};
  cursor: pointer;
  margin-top: 0.5rem;

  max-width: 20rem;
  width: 100%;
  height: 3rem;

  input[type='file'] {
    display: none;
  }
`;

export const InputText = styled.span`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
`;
